import React from 'react'
import PropTypes from 'prop-types';

const TableHeaderRow = ({ name }) => {
    return (
        <>
            <tr className="table-header">
                <td className="user-source-header-item">
                    <span>{name === 'Referrer Rules' ? 'URL Element' : "URL Parameter"}</span>
                </td>
                <td className="user-source-header-item">
                    <span>{"Match Type"}</span>
                </td>
                <td className="user-source-header-item">
                    <span>{"Parameter Value"}</span>
                </td>
                <td className="user-source-header-item">
                    <span>{"User Source"}</span>
                </td>
            </tr>
        </>
    )
}


TableHeaderRow.propTypes = {
     name: PropTypes.string,
};

export default TableHeaderRow
